import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo.svg";

const Header = () => {
  const navigate = useNavigate();
  return (
    <header className="absolute top-0 left-0 w-full z-10 p-6">
      <nav className="flex items-center justify-between">
        <Link to="/" className="text-2xl font-bold text-light-text font-serif">
          <img src={logo} alt="" className="w-[150px]" />
        </Link>
        <div className="hidden md:flex items-center gap-8 text-light-text">
          <a
            href="#about"
            className="hover:text-primary-orange transition-colors"
          >
            About
          </a>
          <a
            href="#how-it-works"
            className="hover:text-primary-orange transition-colors"
          >
            How it works
          </a>
          <a
            href="#footer"
            className="hover:text-primary-orange transition-colors"
          >
            Contact
          </a>
          <button
            onClick={() => navigate("/interest-form")}
            className="bg-primary-orange text-white py-2 px-6 rounded-full font-bold hover:bg-opacity-90 transition-opacity"
          >
            Get Started
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Header;
